"use strict";
// Copyright (c) Microsoft Corporation.
// Licensed under the MIT License.
Object.defineProperty(exports, "__esModule", { value: true });
exports.httpSemanticValues = exports.legacySemanticValues = exports.KnownDependencyColumns = exports.KnownRequestColumns = exports.DependencyTypes = exports.QuickPulseMetricNames = exports.QuickPulseOpenTelemetryMetricNames = void 0;
const semantic_conventions_1 = require("@opentelemetry/semantic-conventions");
var QuickPulseOpenTelemetryMetricNames;
(function (QuickPulseOpenTelemetryMetricNames) {
    QuickPulseOpenTelemetryMetricNames["PHYSICAL_BYTES"] = "azureMonitor.physicalBytes";
    QuickPulseOpenTelemetryMetricNames["PROCESSOR_TIME_NORMALIZED"] = "azureMonitor.percentProcessorTimeNormalized";
    QuickPulseOpenTelemetryMetricNames["REQUEST_RATE"] = "azureMonitor.requestsSec";
    QuickPulseOpenTelemetryMetricNames["REQUEST_FAILURE_RATE"] = "azureMonitor.requestsFailedSec";
    QuickPulseOpenTelemetryMetricNames["REQUEST_DURATION"] = "azureMonitor.requestDuration";
    QuickPulseOpenTelemetryMetricNames["DEPENDENCY_RATE"] = "azureMonitor.dependencyCallsSec";
    QuickPulseOpenTelemetryMetricNames["DEPENDENCY_FAILURE_RATE"] = "azureMonitor.dependencyCallsFailedSec";
    QuickPulseOpenTelemetryMetricNames["DEPENDENCY_DURATION"] = "azureMonitor.dependencyCallDuration";
    QuickPulseOpenTelemetryMetricNames["EXCEPTION_RATE"] = "azureMonitor.exceptionsSec";
})(QuickPulseOpenTelemetryMetricNames || (exports.QuickPulseOpenTelemetryMetricNames = QuickPulseOpenTelemetryMetricNames = {}));
var QuickPulseMetricNames;
(function (QuickPulseMetricNames) {
    // Memory (old)
    QuickPulseMetricNames["COMMITTED_BYTES"] = "\\Memory\\Committed Bytes";
    // Memory (new - current process)
    QuickPulseMetricNames["PHYSICAL_BYTES"] = "\\Process\\Physical Bytes";
    // CPU (old)
    QuickPulseMetricNames["PROCESSOR_TIME"] = "\\Processor(_Total)\\% Processor Time";
    // CPU (new - current process)
    QuickPulseMetricNames["PROCESSOR_TIME_NORMALIZED"] = "\\% Process\\Processor Time Normalized";
    // Request
    QuickPulseMetricNames["REQUEST_RATE"] = "\\ApplicationInsights\\Requests/Sec";
    QuickPulseMetricNames["REQUEST_FAILURE_RATE"] = "\\ApplicationInsights\\Requests Failed/Sec";
    QuickPulseMetricNames["REQUEST_DURATION"] = "\\ApplicationInsights\\Request Duration";
    // Dependency
    QuickPulseMetricNames["DEPENDENCY_RATE"] = "\\ApplicationInsights\\Dependency Calls/Sec";
    QuickPulseMetricNames["DEPENDENCY_FAILURE_RATE"] = "\\ApplicationInsights\\Dependency Calls Failed/Sec";
    QuickPulseMetricNames["DEPENDENCY_DURATION"] = "\\ApplicationInsights\\Dependency Call Duration";
    // Exception
    QuickPulseMetricNames["EXCEPTION_RATE"] = "\\ApplicationInsights\\Exceptions/Sec";
})(QuickPulseMetricNames || (exports.QuickPulseMetricNames = QuickPulseMetricNames = {}));
// copied from exporter constants & added a few more
var DependencyTypes;
(function (DependencyTypes) {
    DependencyTypes["InProc"] = "InProc";
    DependencyTypes["QueueMessage"] = "Queue Message";
    DependencyTypes["Sql"] = "SQL";
    DependencyTypes["Http"] = "Http";
    DependencyTypes["Grpc"] = "GRPC";
    DependencyTypes["Wcf"] = "WCF Service";
    DependencyTypes["mysql"] = "mysql";
    DependencyTypes["postgresql"] = "postgresql";
    DependencyTypes["mongodb"] = "mongodb";
    DependencyTypes["redis"] = "redis";
})(DependencyTypes || (exports.DependencyTypes = DependencyTypes = {}));
var KnownRequestColumns;
(function (KnownRequestColumns) {
    KnownRequestColumns["Url"] = "Url";
    KnownRequestColumns["Duration"] = "Duration";
    KnownRequestColumns["ResponseCode"] = "ResponseCode";
    KnownRequestColumns["Success"] = "Success";
    KnownRequestColumns["Name"] = "Name";
})(KnownRequestColumns || (exports.KnownRequestColumns = KnownRequestColumns = {}));
var KnownDependencyColumns;
(function (KnownDependencyColumns) {
    KnownDependencyColumns["Target"] = "Target";
    KnownDependencyColumns["Duration"] = "Duration";
    KnownDependencyColumns["Success"] = "Success";
    KnownDependencyColumns["Name"] = "Name";
    KnownDependencyColumns["ResultCode"] = "ResultCode";
    KnownDependencyColumns["Type"] = "Type";
    KnownDependencyColumns["Data"] = "Data";
})(KnownDependencyColumns || (exports.KnownDependencyColumns = KnownDependencyColumns = {}));
/**
 * Legacy HTTP semantic convention values
 * @internal
 */
exports.legacySemanticValues = [
    semantic_conventions_1.SEMATTRS_NET_PEER_IP,
    semantic_conventions_1.SEMATTRS_NET_PEER_NAME,
    semantic_conventions_1.SEMATTRS_PEER_SERVICE,
    semantic_conventions_1.SEMATTRS_HTTP_METHOD,
    semantic_conventions_1.SEMATTRS_HTTP_URL,
    semantic_conventions_1.SEMATTRS_HTTP_STATUS_CODE,
    semantic_conventions_1.SEMATTRS_HTTP_ROUTE,
    semantic_conventions_1.SEMATTRS_HTTP_HOST,
    semantic_conventions_1.SEMATTRS_DB_SYSTEM,
    semantic_conventions_1.SEMATTRS_DB_STATEMENT,
    semantic_conventions_1.SEMATTRS_DB_OPERATION,
    semantic_conventions_1.SEMATTRS_DB_NAME,
    semantic_conventions_1.SEMATTRS_RPC_SYSTEM,
    semantic_conventions_1.SEMATTRS_RPC_GRPC_STATUS_CODE,
    semantic_conventions_1.SEMATTRS_EXCEPTION_TYPE,
    semantic_conventions_1.SEMATTRS_EXCEPTION_MESSAGE,
    semantic_conventions_1.SEMATTRS_EXCEPTION_STACKTRACE,
];
/**
 * HTTP semantic convention values
 * @internal
 */
exports.httpSemanticValues = [
    semantic_conventions_1.ATTR_CLIENT_ADDRESS,
    semantic_conventions_1.ATTR_CLIENT_PORT,
    semantic_conventions_1.ATTR_SERVER_ADDRESS,
    semantic_conventions_1.ATTR_SERVER_PORT,
    semantic_conventions_1.ATTR_URL_FULL,
    semantic_conventions_1.ATTR_URL_PATH,
    semantic_conventions_1.ATTR_URL_QUERY,
    semantic_conventions_1.ATTR_URL_SCHEME,
    semantic_conventions_1.ATTR_URL_PATH,
    semantic_conventions_1.ATTR_ERROR_TYPE,
    semantic_conventions_1.ATTR_NETWORK_LOCAL_ADDRESS,
    semantic_conventions_1.ATTR_NETWORK_LOCAL_PORT,
    semantic_conventions_1.ATTR_NETWORK_PROTOCOL_NAME,
    semantic_conventions_1.ATTR_NETWORK_PEER_ADDRESS,
    semantic_conventions_1.ATTR_NETWORK_PEER_PORT,
    semantic_conventions_1.ATTR_NETWORK_PROTOCOL_VERSION,
    semantic_conventions_1.ATTR_NETWORK_TRANSPORT,
    semantic_conventions_1.ATTR_USER_AGENT_ORIGINAL,
    semantic_conventions_1.ATTR_HTTP_REQUEST_METHOD,
    semantic_conventions_1.ATTR_HTTP_RESPONSE_STATUS_CODE,
];
//# sourceMappingURL=types.js.map